import {ChangeDetectionStrategy, Component} from "@angular/core";


@Component({
    selector: 'kort-tittel',
    template: '<ng-content/>',
    styleUrls: ['./kort-tittel.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KortTittelKomponent {

}
